<div *ngIf='(authService.isAuthenticated$ | async) === false' class="container" [attr.dataCy]="generateDataCyId('-welcomeback')">
  <div class="content">
    <span class="title">{{ 'WELCOME_BACK' | translate }}</span>
    <rezolve-basic-button [type]="type" (handleClick)="loginWithRedirect()">
      {{ 'PLEASE_SIGN_IN' | translate }}
    </rezolve-basic-button>
  </div>
</div>
